
<div ref="tooltipContainer" :class="tooltipClass">
  <button type="button" class="tooltip-btn" :class="[buttonColor]" data-toggle="tooltip" :title="helpText" >
    <icon class="help" aria-hidden="true"></icon>
  </button>
</div>
